import React from 'react'
import { graphql } from 'gatsby'
import { builder, BuilderComponent } from '@builder.io/react'

import '@builder.io/widgets'
import './components/vimeo'
import './components/gatsby-link'
import './components/where-to-buy'
builder.init('47c5d023e7b3451a86ac03602c65dce8')

export const pageQuery = graphql`
	query ($path: String!) {
		allBuilderModels {
			oneAlesisDrumsPage(target: { urlPath: $path }, options: { cachebust: true }) {
				content
				data { 
					title
				}
			}
		}
	}
`

export const Head = (props) => {
    const models = props.data?.allBuilderModels
    const title = models?.oneAlesisDrumsPage?.data?.title
    const description = models?.oneAlesisDrumsPage?.data?.description
    const image = models?.oneAlesisDrumsPage?.data?.image
    const url = models?.oneAlesisDrumsPage?.data?.url
    return (
        <>
            {title && <>
                <title>{title}</title>
                <meta property="og:title" content={title} />
                <meta name="twitter:title" content={title} />
            </>}
            {description && <>
                <meta name="description" content={description} />
                <meta property="og:description" content={description} />
                <meta name="twitter:description" content={description} />
            </>}
            {image && <>
                <meta name="image" content={image} />
                <meta property="og:image" content={image} />
                <meta name="twitter:image" content={image} />
            </>}
            {url && <>
                <meta property="og:url" content={url} />
                <meta name="twitter:url" content={url} />
            </>}
        </>
    )
}

export default function BuilderIOPage(props) {
    const models = props.data?.allBuilderModels
    const page = models?.oneAlesisDrumsPage?.content
    return <BuilderComponent model="alesis-drums-page" content={page} />
}
